import React from 'react';
import { Footer } from './styled';
import { Logo } from 'ui';
import { SocialMedia, Copyright } from 'components/Molecules';
import Links from './Links';
import Newsletter from '../Newsletter';

const index = () => {
  return (
    <Footer>
      <Logo/>
      <SocialMedia/>
      <Links/>
      <Newsletter/>
      <Copyright/>
    </Footer>
  )
}

export default index
